import { render, staticRenderFns } from "./RegistrationDetailsCustomer.vue?vue&type=template&id=aeed3d82"
import script from "./RegistrationDetailsCustomer.vue.ts?vue&type=script&lang=ts&external"
export * from "./RegistrationDetailsCustomer.vue.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports